import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { PeymentService } from '@api/peyment.service';
import jalaliMoment = require('jalali-moment');
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-withdraw',
  templateUrl: './withdraw.component.html',
  styleUrls: ['./withdraw.component.scss']
})
export class WithdrawComponent implements OnInit {

  startPage = 1;
  pageSize = 100;
  totalPage = 0;
  public destroy$ = new Subject<void>();
  withdrowList: any;

  constructor( private paymentService: PeymentService) { }

  ngOnInit(): void {
    this.paymentService.withdrawRequest(this.startPage ,this.pageSize ).pipe(takeUntil(this.destroy$ )).subscribe(
      (res: any) => {
        this.withdrowList = res;
        this.withdrowList.resList.forEach((element): any => {
          const miladiDate = new Date(); 
          element.requestTime = jalaliMoment(miladiDate).format('jYYYY/jMM/jDD hh:mm');
        });
      }
    )
  }
  public getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize
    this.paymentService.withdrawRequest((event.pageIndex) + 1 , this.pageSize).pipe(takeUntil(this.destroy$ )).subscribe(
      (res) => {
        this.withdrowList = res;
  }
    )}
}
